import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IProduct } from '@app/models/product.interface';
import { DialogData } from '@app/modules/organization/areas-table/form/form.component';
import { first } from 'rxjs';

@Component({
  selector: 'app-confirm-update',
  templateUrl: './confirm-update.component.html',
  styleUrls: ['./confirm-update.component.scss']
})
export class ConfirmUpdateComponent implements OnInit {

  public displayedColumns$: String[] = ['name', 'prdCode'];
  public isLoading$ = false;
  public isConfirmed$ = true
  public updated$ = [];
  public created$  = [];
  public failed$ = [];
  public items$: IProduct[] = [];

  @Output() save$ = new EventEmitter<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data$,
    public _matDialogRef: MatDialogRef<ConfirmUpdateComponent>,
  ) { 
  }

  public onSubmit(){

  }

  ngOnInit(): void {

  }

  public callback(){

  }

  createRange(number) {
    return new Array(number);
  }

}
